import React from 'react';
import { useTranslation } from 'react-i18next';
import Stars from '@/components/general/Stars';
import { getTranslatedReview } from '../utils';
import { isElalCompany } from '@/utils/isCompany';

const HotelCardReviewComponent = ({ hotel }) => {
  const { t } = useTranslation();
  const isElal = isElalCompany();
  const { stars, hasReview, review, stars_hide } = hotel;

  const hideSeparator = stars_hide && !hasReview;

  const reviewItems = [
    {
      type: 'component',
      content: <Stars stars={stars} hide={stars_hide} />,
      condition: true,
    },
    {
      type: 'text',
      content: '|',
      className: 'review-seperator',
      condition: hasReview && !hideSeparator,
    },
    {
      type: 'text',
      content: review?.score,
      className: 'review-score',
      condition: hasReview && !isElal && review,
    },
    {
      type: 'text',
      content: review ? getTranslatedReview(review.description, t) : '',
      className: 'review-description',
      condition: hasReview && review,
    },
    {
      type: 'text',
      content: review?.score,
      className: 'elal-review-score',
      condition: hasReview && isElal && review,
    },
    {
      type: 'text',
      content: review
        ? `(${review.votes.toLocaleString()} ${t('Reviews')})`
        : '',
      className: isElal ? 'elal-review-votes' : '',
      condition: hasReview && review,
    },
    {
      type: 'text',
      content: t('ScoreNotAvailable'),
      className: '',
      condition: !hasReview,
    },
  ];

  const reviewMarkup = reviewItems
    .filter(item => item.condition)
    .map((item, index) => {
      switch (item.type) {
        case 'text':
          return (
            <span key={index} className={item.className}>
              {item.content}
            </span>
          );
        case 'component':
          return <React.Fragment key={index}>{item.content}</React.Fragment>;
        default:
          return null;
      }
    });

  return <div className="hotel-review">{reviewMarkup}</div>;
};

export default HotelCardReviewComponent;